<!--
PARA QUE ESTE COMPONENTE FUNCIONE BIEN, TENEMOS 
QUE IMPLEMENTAR LOS SIGUIENTES METODOS EN EL PADRE:

cambioBusiness(idBusinessData, listTpv) {},
emitirConsulta() {},
cambioTpv(idTpvData) {},
cambioHora(dates) {},
cambiarExtra(idExtraElement){}, //SOLO SI conBuscador=true

-->
<template>
  <div class="col-md-12">
    <div class="card">
      <div class="row">
        
        <div class="col-md-2" v-if="sectores">
          <div class="form-group">
            <label for="listSectores">{{ 'Sector' }}</label>
            <el-select class="select-default" style="width: 100%;" size="large" v-model="idSectorData" filterable @change="cambioSector()" :placeholder="'Selecciona un sector'">
              <el-option v-for="(sector, index) in listSectores" class="select-primary" :value="sector.id" :label="sector.name" :key="index"></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-md-2" v-if="idCompany != 0">
          <div class="form-group">
            <label for="listCompanies">{{ 'Empresa' }}</label>
            <el-select class="select-default" style="width: 100%;" size="large" v-model="idCompanyData" filterable @change="cambioCompany()" :placeholder="'Selecciona una empresa'">
              <el-option v-for="(company, index) in listCompanies" class="select-primary" :value="company.id" :label="company.fiscalName" :key="index"></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-md-2" v-if="!sectores">
          <div class="form-group" v-if="conTodosTodos == false">
            <label for="listBusiness">{{ $t("negocio") }}</label>
            <el-select v-if="listBusinesses.length === 0" class="select-default" style="width: 100%;" size="large" value="" disabled placeholder="Obteniendo negocios..."></el-select>
            <el-select v-else class="select-default select-negocio" style="width: 100%;" size="large" v-model="idBusinessData" filterable :disabled="disableBusinessSelect" v-tooltip.top-center="disableBusinessSelect ? $t('negocioBloqueadoConsultasEnCurso') : ''" @change="cambioBusiness()" :placeholder="$t('seleccionaNegocio')">
              <el-option v-for="(business, index) in listBusinesses" class="select-primary" :value="business.id" :label="business.establishmentName" :key="index"></el-option>
            </el-select>
          </div>
          <div class="form-group" v-else>
            <label for="listBusiness">{{ $t("negocio") }}</label>
            <el-select v-if="listBusinesses.length === 0" class="select-default" style="width: 100%;" size="large" value="" disabled placeholder="Obteniendo negocios..."></el-select>
            <el-select v-else class="select-default select-negocio" style="width: 100%;" size="large" v-model="idBusinessData" filterable :disabled="disableBusinessSelect" v-tooltip.top-center="disableBusinessSelect ? $t('negocioBloqueadoConsultasEnCurso') : ''" @change="cambioBusiness()" :placeholder="$t('seleccionaNegocio')">
              <el-option class="select-primary" :value="-1" :label="'Todos'"></el-option>
              <el-option v-for="(business, index) in listBusinesses" class="select-primary" :value="business.id" :label="business.establishmentName" :key="index"></el-option>
            </el-select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label for="listTPV">{{ $t("TPV") }}</label>
            <div v-if="conTodos == false && conTodosTodos == false">
              <el-select class="select-default" style="width: 100%;" size="large" v-model="idTpvData" filterable @change="cambioTpv()" placeholder="SeleccionaTPV" :disabled="idBusinessData == -1 && !sectores">
                <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id" :label="tpv.nameShow" :key="tpv.id"></el-option>
              </el-select>
            </div>
            <div v-else>
              <el-select class="select-default" style="width: 100%;" size="large" v-model="idTpvData" filterable @change="cambioTpv()" placeholder="SeleccionaTPV" :disabled="idBusinessData == -1 && !sectores">
                <el-option class="select-primary" :value="-1" :label="'Todos'"></el-option>
                <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id" :label="tpv.nameShow" :key="tpv.id"></el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="col-md-2" v-if="conBuscador">
          <div class="form-group">
            <label for="productos">{{ textoExtra.charAt(0).toUpperCase() + textoExtra.slice(1) }}</label>
            <el-select class="select-default" style="width: 100%;" size="large" v-model="idExtraElement" filterable remote data-is-search="true" :placeholder="textoExtraPlaceholder" @change="emitirConsulta()" :remote-method="search">
              <el-option v-for="p in listExtraElement" class="select-primary" :value="p.id" :label="p.active == '1' ? p.name : p.name + ' [' + $t('BAJA') + ']'" :key="p.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-2" v-if="conBuscadorRepartidor">
          <div class="form-group">
            <label for="repartidor">{{ textoExtra.charAt(0).toUpperCase() + textoExtra.slice(1) }}</label>
            <el-select class="select-default" style="width: 100%;" filterable size="large" v-model="idRepartidorData" :placeholder="textoExtraPlaceholder" @change="emitirConsulta()">
              <el-option v-for="(worker, index) in nombresRepartidores" :key="worker.id" :value="worker.name" :label="worker.name" @click="handleWorkerSelect(worker)" />
            </el-select>
          </div>
        </div>

        <div class="col-md-2" v-if="!quitarFechas">
          <div class="form-group">
            <label>{{ $t("fechaInicio") }}</label>
            <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy" @input="cambioHora()" :title="$t('fechaInicio')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" v-model="dates[0]"></datetime>
          </div>
          <div v-if="busquedaPorHoras" class="form-group" style="margin-top: -5px;">
            <label>{{ $t("horaInicio") }}</label>
            <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" type="time" @change="cambioHorasBusqueda()" :title="$t('horarioInicio')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" format="HH:mm" v-model="hoursdesde"></datetime>
          </div>
        </div>

        <div class="col-md-2" v-if="!quitarFechas">
          <div class="form-group">
            <label>{{ $t("fechaFin") }}</label>
            <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" :title="$t('fechaFin')" format="dd-MM-yyyy" @input="cambioHora()" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" v-model="dates[1]"></datetime>
          </div>
          <div v-if="busquedaPorHoras" class="form-group" style="margin-top: -5px;">
            <label>{{ $t("horaFin") }}</label>
            <datetime :value-zone="timezoneId" :auto="true" type="time" class="theme-numier" :title="$t('horaFin')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" @change="cambioHorasBusqueda()" input-class="form-control" format="HH:mm" v-model="hourshasta"></datetime>
          </div>
        </div>

        <div class="col-md-2" v-if="!quitarConsultas">
          <label class="d-none d-md-block" style="margin-bottom: 7px;">&nbsp;</label> 
          
          <div class="form-group clase-boton-consulta mt-3 mt-md-0" style="margin-bottom: 5px;">
            
            <button v-if="!gStock" 
              class="btn btn-primary btn-block" 
              :disabled="listBusinesses.length === 0 || cargando" 
              @click="emitirConsulta()"
              style="display: flex; align-items: center; justify-content: center; height: 40px; gap: 10px;"
            >
              <i v-if="cargando" class="fa fa-refresh fa-spin"></i>
              <i v-else class="fa fa-search"></i>
              <span>{{ cargando ? 'Consultando...' : $t("consultar") }}</span>
            </button>

            <button v-else 
              class="btn btn-primary btn-block mt-3 mt-md-0" 
              :disabled="listBusinesses.length === 0 || cargando" 
              @click="emitirConsulta()"
              style="display: flex; align-items: center; justify-content: center; height: 40px; gap: 10px;"
            >
              <i v-if="cargando" class="fa fa-refresh fa-spin"></i>
              <i v-else class="fa fa-upload"></i>
              <span>{{ cargando ? 'Exportando...' : $t("exportar") }}</span>
            </button>
          </div>

        <div class="form-group" v-if="conBusquedaPorHoras" style="margin-bottom: 0; margin-top: 10px;">
          <el-checkbox v-model="busquedaPorHoras" @change="cambioBuscarPorHoras()">
            <small><strong>{{ $t("buscarPorHoras") }}</strong></small>
          </el-checkbox>
        </div>

        <div class="form-group" v-if="conFiltrarPorFecha" style="margin-bottom: 0; margin-top: 10px;">
          <el-checkbox v-model="filtrarPorFecha">
            <small><strong>{{ $t("filtrarPorFecha") }}</strong></small>
            <i v-tooltip.top-center="'Si esta opción está activada, filtrará por dias naturales, no por fecha de apertura de caja.'" class="fa fa-info-circle"></i>
          </el-checkbox>
        </div>
      </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup,
  Loading
} from "element-ui";
import moment from "moment";

export default {
  props: {
    listBusinesses: Array,
    listTpv: Array,
    listSectores: Array,
    listworkers: Array,
    nombresRepartidores: {
      type: Array,
      required: false,
    },
    cargando: {
      type: Boolean,
      default: false
    },
    listCompanies: Array,
    idBusiness: [Number, String],
    idTpv: [Number, String],
    idSector: [Number, String],
    idCompany: { default: 0 },
    dateto: [Date, String],
    datefrom: [Date, String],
    hoursto: [String],
    hoursfrom: [String],
    quitarFechas: { default: false },
    quitarConsultas: { default: false },
    gStock: { default: false },
    conTodos: { default: false },
    conFiltrarPorFecha: { default: false },
    activarVolver: { default: false },
    conBuscador: { default: false },
    conBuscadorRepartidor: { default: false },
    necesarioBuscador: { default: true },
    conBusquedaPorHoras: { default: false },
    sectores: { default: false },
    textoExtra: [String],
    textoExtraPlaceholder: [String],
    listElmExtra: Array,
    conTodosTodos: { default: false },
    emitirConsultaEnPadre: {default: true},
    disableBusinessSelect: { default: false }
  },

  mounted() {
    if (this.idBusiness && !this.cargaInicial) {
      this.cargaInicial = true;
      this.idSectorData = this.idSector;
      this.idBusinessData = this.idBusiness;
      this.cambioBusiness();
    }
  },

  data() {
    return {
      idRepartidorData: null,
      list: [],
      listNameWorkers: [],
      /*
      workers: {
        id: ,
        name: 
      }
      */
      idBusinessData: this.idBusiness !== null && this.idBusiness !== undefined ? this.idBusiness : -1,
      idTpvData: this.idTpv !== null && this.idTpv !== undefined ? this.idTpv : -1,
      
      // dates: [this.datefrom, this.dateto],
      dates: [
        new Date().toISOString(),  // Siempre día actual para fecha inicio
        new Date().toISOString()   // Siempre día actual para fecha fin
      ],
      hoursdesde: this.hoursfrom,
      hourshasta: this.hoursto,
      // idBusinessData: 0,
      idCompanyData: 0,
      idSectorData: this.listSectores && this.listSectores[0].id ? this.listSectores[0].id : -1,
      // idTpvData: -1,
      listTpvData: [],
      listBusinessData: [],
      filtrarPorFecha: false,
      idExtraElement: 0,
      listExtraElement: this.listElmExtra,
      busquedaPorHoras: false,
      cargaInicial: false,
      searchProductosQuery:'',
      listBusinessesCompany: []
    };
  },

  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  computed: {
    timezoneId() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
  },
  beforeUpdate() {
    this.idBusinessData = this.idBusiness;
    this.idCompanyData = this.idCompany;
    this.idTpvData = this.idTpv;

    if (this.idTpv) {
      this.idTpvData = this.idTpv;
    }

    if (this.idSector) {
      this.idSectorData = this.idSectorData;
    }

  },

  watch: {
    listElmExtra: {
      deep: true,
      handler(act, cur) {
        this.listExtraElement = act;
        this.idRepartidorData = act;
      },
    },
    idBusiness() {
      //Carga inicial está para que sólo se ejecute cuando cargue el informe por primera vez
      if (this.idBusiness != 0 && !this.cargaInicial) {
        this.cargaInicial = true;
        this.idSectorData = this.idSector;
        this.idBusinessData = this.idBusiness;
        this.cambioBusiness();
      }
    },
  },
  methods: {
    _startParentLoading() {
      if ('loadingResults' in this.$parent) {
        this.$parent.loadingResults = true;
      } else {
        this.$parent.loading = Loading.service({ text: 'Cargando...' });
      }
    },
    _stopParentLoading() {
      if ('loadingResults' in this.$parent) {
        this.$parent.loadingResults = false;
      } else if (this.$parent.loading && typeof this.$parent.loading.close === 'function') {
        this.$parent.loading.close();
      }
    },
    volver() {
      if (!this.conFiltrarPorFecha) return;
      this.listTurnos = [];
      this.mostrarTurnos = false;
    },
    emitirConsulta() {
      // console.log("Emitir consulta");
      // console.log(this.activarVolver);
      if (this.conBuscador) {
        if (isNaN(parseInt(this.idExtraElement))) {
          this.idExtraElement = ""
          //return;
        }
        this.$parent.cambiarExtra(this.idExtraElement);
      }
      if (this.conBuscadorRepartidor) {
        const repartidorSeleccionado = this.nombresRepartidores.find(worker => worker.id === this.idRepartidorData);
        const nombreRepartidor = repartidorSeleccionado ? repartidorSeleccionado.name : '';
        this.$emit('repartidorConsultado', { id: this.idRepartidorData, nombre: nombreRepartidor });
      }
      if (this.conFiltrarPorFecha && this.filtrarPorFecha && this.activarVolver) {
        this.$emit('consultarVolver');
        // console.log("Emitir consulta con volver activado");
      }

      this.$emit('consultar');

      if (this.emitirConsultaEnPadre) {
        if (this.conFiltrarPorFecha) {
          this.$parent.emitirConsulta(this.filtrarPorFecha);
        } else if (this.busquedaPorHoras) {
          this.cambioHorasBusqueda();
          this.$parent.emitirConsulta();
        } else {
          this.$parent.emitirConsulta();
        }
      }
      this.$store.dispatch("setDateTo", moment(this.dateto).format());
      this.$store.dispatch("setDateFrom", moment(this.datefrom).format());
    },

    cambioTpv() {
      this.idExtraElement = "";
      if (this.conFiltrarPorFecha) {
        this.$parent.cambioTpv(this.idTpvData);
      } else {
        this.$parent.cambioTpv(this.idTpvData, this.filtrarPorFecha);
      }
    },

    cambioHora() {
      this.$parent.cambioHora(this.dates);
    },
    cambioBuscarPorHoras() {
      this.$parent.cambioBuscarPorHoras(this.busquedaPorHoras);
    },
    cambioHorasBusqueda() {
      this.$parent.cambioHorasBusqueda(this.hoursdesde, this.hourshasta);
    },
    search(query) {
      this.idExtraElement = query;
      //this.listExtraElement = this.$parent.searchCabecera(query)
      this.$parent.searchCabecera(query);
      if (query) {
        this.filteredWorkers = this.nombresRepartidores.filter(worker =>
        worker.workerName
        );
      } else {
        this.filteredWorkers = this.listElmExtra;
      }
    },
    cambioSector() {

      this._startParentLoading();
      let sectorData = this.idSectorData;

      this.listExtraElement = [];
      this.idRepartidorData = [];
      this.idExtraElement = "";
      this.listBusinessData = [];

      if (sectorData != 0) {
        let config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        };

        var params = {
          idBusiness: this.listSectores.find((sector) => sector.id == sectorData).idBusinessMaster,
          idSector: this.idSectorData,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
          .then(function (response) {

            if (response.data.response) {

              //Recojo todos los negocios de la carga inicial del sector seleccionado
              vm.listBusinessData = response.data.result;
              
              vm.idBusinessData = -1;
              vm.$parent.cambioSector(sectorData, vm.listBusinessData);
              vm._stopParentLoading();

            } else {
              vm._stopParentLoading();
            }

          }).catch(function (error) {
            console.log(error);
            vm._stopParentLoading();
          })
      } else {
        const sector = this.listSectores.find(sector => sector.id == this.idSectorData);
        this.listBusinessData = sector.negocios;
        this.$parent.cambioSector(sectorData, this.listBusinessData);
        this._stopParentLoading();
      }
    },
    cambioCompany() {

      this._startParentLoading();

      let companyData = this.idCompanyData;
      this.listBusinessData = [];

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idCompany: this.idCompany,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
        .then(function (response) {

          vm.listBusinessData = response.data.result;
          vm.idBusinessData = -1;
          vm.$parent.cambioCompany(companyData, vm.listBusinessData);
          vm._stopParentLoading();

        })
        .catch(function (error) {
          console.log(error);
          vm._stopParentLoading();
        });
    },
    cambioBusiness() {
      let businessData = this.idBusinessData;
      this.listExtraElement = [];
      this.idRepartidorData = [];
      this.idExtraElement = "";
      this.listTpvData = [];

      const vm = this;
      const configBase = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      if (businessData == -1) {
        let businesses = this.listBusinesses
          .filter(b => b.id != -1)
          .map(b => parseInt(b.id));

        const config = {
          ...configBase,
          params: {
            idBusiness: businesses,
            jwt: this.$store.getters.jwt,
          },
        };

        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listTpvData = response.data.result;
              if (vm.listTpvData.length > 0) {
                vm.idTpvData = vm.conTodos ? -1 : vm.listTpvData[0].id;
                vm.$parent.cambioBusiness(businessData, vm.listTpvData);
              } else {
                vm.idTpvData = -1;
              }
            }
          })
          .catch(console.error)
          .finally(() => {
            vm._stopParentLoading();
          });
      } else {
        const config = {
          ...configBase,
          params: {
            idBusiness: businessData,
            jwt: this.$store.getters.jwt,
          },
        };

        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listTpvData = response.data.result;
              if (vm.listTpvData.length > 0) {
                vm.idTpvData = vm.conTodos ? -1 : vm.listTpvData[0].id;
                vm.$parent.cambioBusiness(businessData, vm.listTpvData);
              } else {
                vm.idTpvData = -1;
              }
            }
          })
          .catch(console.error)
          .finally(() => {
            vm._stopParentLoading();
          });
      }

      if (this.gStock) {
          if (businessData == -1) {
            this._emitBusinessesCompanyFromAvailableBusinesses();
          } else {
            // Llamada al endpoint businesses/IdsAndNamesByCompanyId
            const postData = {
              idBusiness: businessData,
              jwt: this.$store.getters.jwt,
            };

            const postConfig = {
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            this.axios
              .post(
                this.$store.getters.apiUrl + "businesses/IdsAndNamesByCompanyId",
                postData,
                postConfig
              )
              .then(res => {
                // Validar y transformar la respuesta
                const businesses = Array.isArray(res.data) ? res.data : res.data.result || [];
                if (businesses.length === 0) {
                  this._emitBusinessesCompanyFromAvailableBusinesses();
                  return;
                }
                this.listBusinessesCompany = businesses.map(item => ({
                  id: item.id,
                  establishmentName: item.establishmentName || item.name || 'Sin nombre'
                }));
                this.$emit('businessesCompanyUpdated', this.listBusinessesCompany);
              })
              .catch(err => {
                const errData = err.response ? err.response.data : err.message;
                console.error("Error al obtener negocios por companyId:", errData);
                this._emitBusinessesCompanyFromAvailableBusinesses();
              });
          }
        }
      },

      _emitBusinessesCompanyFromAvailableBusinesses() {
        const businesses = Array.isArray(this.listBusinesses) ? this.listBusinesses : [];
        this.listBusinessesCompany = businesses.map(item => ({
          id: item.id,
          establishmentName: item.establishmentName || item.name || 'Sin nombre'
        }));
        this.$emit('businessesCompanyUpdated', this.listBusinessesCompany);
      },

    handleWorkerSelect(worker) {
      this.idRepartidorData = worker.id;
      this.$emit('repartidorSeleccionado', worker);
    },

  //  cambioBusiness() {
  //   try {
  //     const response = axios.post('http://localhost:8082/businesses/IdsAndNamesByCompanyId', {
  //       idBusiness: this.idBusinessData,  // viene del selector
  //       jwt: this.jwtToken                 // tu token JWT definido en data o store
  //     });
  //     // Actualiza lo que necesites con la respuesta
  //     this.listBusinesses = response;
  //     // O cualquier otro dato que te devuelva el endpoint
  //   } catch (error) {
  //     console.log('error');
  //   }
  // }

  },
};
</script>
<style>
.theme-numier .vdatetime-calendar__month {
  height: 344.062px !important;
}

.theme-numier .vdatetime-year-picker__list,
.theme-numier .vdatetime-month-picker__list {
  height: 392.062px !important;
}
</style>
<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.econtainer div {
  padding-right: 15px;
}

button:disabled {
  background-color: #999999 !important;
  border-color: #777777 !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

.select-negocio /deep/ .el-input__inner:disabled {
  background-color: #eef0f1 !important;
  border-color: #d9d9d9 !important;
  color: #909399 !important;
  cursor: not-allowed !important;
}

button:disabled:hover {
  background-color: #999999 !important;
  border-color: transparent !important;
}
@media (min-width: 768px) {
  .clase-boton-consulta {
    max-width: 135px;
  }
}

@media (max-width: 767px) {
  .clase-boton-consulta {
    width: 100%;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CabeceraInformes/CabeceraInformes.vue